import { Component, Input, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-meeting-timer',
  templateUrl: './meeting-timer.component.html',
  styleUrls: ['./meeting-timer.component.css']
})
export class MeetingTimerComponent implements OnInit {

  @Input() meetResp!:any;
  meetingActualStartTime: any;
  meetingTimerVal: any;

  @ViewChild('meetingTimer') meetingTimer: any;

  constructor() {
    
   }

  ngOnInit(): void {

    
  //  setTimeout(() => {
  
  //   this.getMeetingTimer();
  //  }, 5);
    
  }

  ngAfterViewInit() {

    setTimeout(() => {
      
      this.getMeetingTimer();
     }, 1000);


  }
  

  getMeetingTimer(){

    if(this.meetResp.meetingStartTimeInMilliSec != null && this.meetResp.meetingStartTimeInMilliSec != undefined){
      this.meetingActualStartTime = this.meetResp.meetingStartTimeInMilliSec;
    }else if(this.meetResp.meetingDateInLong != null && this.meetResp.meetingDateInLong != undefined){
      this.meetingActualStartTime = this.meetResp.meetingDateInLong;
    }
    
    
    if(this.meetingActualStartTime != null && this.meetingActualStartTime != undefined){
    var currentTime:any;
    var meetingActulaStarttime:any;
    var curSysDate=new Date();
    var meetUtc = new Date( moment.utc().format() ).getTime()//current utc date with time
    
  
    if(meetUtc!=null){
      currentTime = this.millisToMinutesAndSeconds(meetUtc);
    }
  
    
    if(this.meetResp.meetingStartTimeInMilliSec != null){
      meetingActulaStarttime =  this.millisToMinutesAndSeconds(this.meetResp.meetingStartTimeInMilliSec);
    }
    
  
    this.meetingTimerVal = currentTime-meetingActulaStarttime;
    setTimeout(() => {

      this.meetingTimer.start();
    },10)
    
    

  }
  
  }
    millisToMinutesAndSeconds(millis: any) {
      var seconds = ((millis) / 1000);
      return seconds;
    }

}
